import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { hasActiveProductsToBeDisplayed } from "@qgiv/p2p-registration";
import { selectIsCms } from "../../redux/slices/configSlice";
import { selectAllRegistration } from "../../redux/slices/registrationSlice";
import { selectAllProducts } from "../../redux/slices/productsSlice";
import { selectAllProductSettings } from "../../redux/slices/productSettingsSlice";
import DeliveryNoteControl from "./DeliveryNoteControl";

const ConnectedDeliveryNoteControl = ({ controlId }) => {
    const isCms = useSelector(selectIsCms);
    const registration = useSelector(selectAllRegistration);
    const { storeCart = [] } = registration;
    const products = useSelector(selectAllProducts);
    const productSettings = useSelector(selectAllProductSettings);
    const { deliveryInfo = "" } = productSettings;

    const hasProducts = hasActiveProductsToBeDisplayed(products);

    const hasDeliveryNote = deliveryInfo.length > 0;

    const hasItemsInCart = storeCart && storeCart.length > 0;

    const isVisible = !!(
        hasProducts &&
        hasDeliveryNote &&
        (isCms || (!isCms && hasItemsInCart))
    );

    const deliveryNoteControlProps = {
        controlId,
        isVisible,
    };

    return <DeliveryNoteControl {...deliveryNoteControlProps} />;
};

ConnectedDeliveryNoteControl.propTypes = {
    controlId: PropTypes.number.isRequired,
};

export default ConnectedDeliveryNoteControl;
